import "./LogoGarden.css";
import React from "react";
import map from "lodash/map";
import PropTypes from "prop-types";
import logoData from "../data/logoData";
import ContentItem from "shared/components/cms/ContentItem";

const LogoGarden = ({ logos = logoData }) => (
    <div className="logo-garden">
        <ContentItem className="logo-header" tag="h5" contentKey="logoGardenHeader" />
        <div className="logo-images">
            {map(logos, ({ src, alt }, i) => <img className="logo" key={alt + i} src={src} alt={alt} />)}
        </div>
    </div>
);

LogoGarden.propTypes = {
    logos: PropTypes.arrayOf(PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
    }))
};

export default LogoGarden;